// components/invisalign/InvisalignFAQs.tsx
"use client";

import React from "react";
import FAQ from "@/components/tools/FAQ";

const InvisalignFAQs: React.FC = () => {
  const faqs = [
    {
      question: "How much does invisalign cost in Astoria, NY?",
      answer: "The price of Invisalign in Astoria depends on how much correction your teeth need, so costs vary case to case. Many PPO insurance plans help cover part of it, and Smile4Me offers financing up to 2 years at 0% interest for the rest. A consultation gives you an exact number, not a generic estimate.",
      links: [
        {
          text: "Smile4Me offers financing",
          url: "https://smile4mecare.com/financing-insurance/"
        }
      ]
    },
    {
      question: "How long does invisalign treatment take?",
      answer: "Most Invisalign cases in Astoria run 12 to 18 months, though mild cases can finish in as little as six. Wearing your aligners 20 to 22 hours a day keeps you on schedule; skipping days stretches it out. Your first visit at Smile4Me includes a personalized timeline for your case."
    },
    {
      question: "Is Invisalign painful?",
      answer: "Invisalign isn't painful the way traditional braces can be, since there are no brackets or wires to irritate your mouth. You may feel mild pressure for a day or two after switching to a new aligner, which fades quickly. Most patients find it far more comfortable than metal braces.",
      links: [
        {
          text: "Invisalign isn't painful",
          url: "https://smile4mecare.com/blog/does-invisalign-hurt/"
        }
      ]
    },
    {
      question: "Can I eat and drink with Invisalign aligners In?",
      answer: "Aligners come out before eating or drinking anything but plain water, so there's no list of restricted foods to track. After a meal, just rinse your mouth, brush if you can, and put them back in."
    },
    {
      question: "How do I clean my Invisalign aligners?",
      answer: "Rinse aligners every time they come out, and brush them gently with a soft toothbrush; skip regular toothpaste, since it can scratch the plastic. Invisalign cleaning crystals or a denture cleaner work well a few times a week. Brush your own teeth before putting aligners back in, too.",
      links: [
        {
          text: "Invisalign cleaning",
          url: "https://smile4mecare.com/blog/how-to-clean-invisalign-trays/"
        }
      ]
    },
    {
      question: "Am I a good candidate for Invisalign in Astoria?",
      answer: "Invisalign works well for teens and adults with mild-to-moderate crowding, spacing, or bite issues; which covers most patients who ask about it. Severe skeletal bite problems may still need braces or surgery. A free consultation at Smile4Me is the most reliable way to know for sure."
    }
  ];

  return (
    <section className="w-full py-10 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <FAQ title="FAQs About Invisalign Astoria Offers" faqs={faqs} />
      </div>
    </section>
  );
};

export default InvisalignFAQs;
